import { IFetchCustomerContractsDTO } from 'modules/customer/domain/dtos';
import { IContractsRepository } from 'modules/customer/domain/repositories';

export class FetchCustomerContractsUseCase {
  constructor(private contractsRepository: IContractsRepository) {}

  public async execute({
    customerId,
    page,
    signed,
    size,
  }: IFetchCustomerContractsDTO) {
    return this.contractsRepository.findAll({ customerId, page, signed, size });
  }
}
